import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  return {
    alerts: _defineProperty({
      position: 'fixed',
      pointerEvents: 'none',
      width: '100%',
      boxSizing: 'border-box',
      zIndex: componentTheme.alertsZIndex,
      paddingLeft: componentTheme.alertsPadding,
      paddingRight: componentTheme.alertsPadding,
      paddingTop: componentTheme.alertsTopPadding
    }, mq, {
      padding: componentTheme.alertsMobilePadding
    }),
    alertHolder: {
      pointerEvents: 'auto'
    }
  };
};
export default generateStyle;